const steps = [
  {
    no: '01',
    title: '先确认系统版本',
    desc: '在手机「设置 - 关于本机」里查看系统号，Android 7.0 及以上都能正常安装，低于此版本建议先升级系统。',
    tip: '常见问题：提示"解析包出错"，多半是系统版本过低。',
  },
  {
    no: '02',
    title: '允许本次安装',
    desc: '部分机型会拦截非应用商店来源，按提示进入「设置 - 安全 - 安装未知应用」，为本页来源打开开关即可继续。',
    tip: '常见问题：安装按钮点不动，通常是权限没放行。',
  },
  {
    no: '03',
    title: '装好后检查更新',
    desc: '首次打开建议在设置里点一次「检查更新」，确保拿到的是最新版，旧版残留的卡顿问题会随之消失。',
    tip: '常见问题：升级后仍卡，先清理旧版缓存再试。',
  },
];

export default function InstallGuide() {
  return (
    <section id="install" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 xl:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4 reveal reveal-1">
            <span className="text-xs md:text-sm font-medium text-accent-700 tracking-wide">
              安装指引
            </span>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              手机端安装，
              <br className="hidden md:block" />
              三步走完
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              新手照着做就行，装不上多半卡在这几步上。把过程拆开看，问题其实都不复杂。
            </p>
            <div className="mt-8 rounded-lg bg-background-50 border border-background-200 p-5">
              <div className="flex items-start gap-3">
                <span className="w-9 h-9 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className="ri-lightbulb-line text-lg"></i>
                </span>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  不确定装哪一版？页面顶部的「版本速览」已经把三种入口的需求说清楚了。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col">
              {steps.map((step, idx) => (
                <div
                  key={step.no}
                  className={`reveal reveal-${idx + 1} flex gap-5 md:gap-7 py-6 md:py-8 ${
                    idx !== steps.length - 1 ? 'border-b border-background-300' : ''
                  }`}
                >
                  <span className="font-heading font-bold text-2xl md:text-3xl text-primary-500 shrink-0 w-12 md:w-14">
                    {step.no}
                  </span>
                  <div>
                    <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {step.desc}
                    </p>
                    <p className="mt-3 inline-flex items-start gap-2 text-xs md:text-sm text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-md">
                      <i className="ri-question-line text-sm mt-0.5"></i>
                      {step.tip}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}